// Convert a phone number to a dash-separated format (e.g. 555-123-4567)

const NON_NUMERIC = /\D+/g

function formatPhoneNumber(original) {
  if (typeof original !== 'string') return original

  let num = original.replace(NON_NUMERIC, '')

  // Strip off the country code (assumes North American numbers)
  if (num[0] === '1') num = num.substr(1)

  // Don't format the phone number until they have finished typing it, otherwise
  // attempts to edit the start/middle of the number will cause the cursor to
  // jump back to the right/end of the text input field.
  if (num.length < 10) return original

  if (num.length > 6) num = num.substr(0,6) + '-' + num.substr(6)
  if (num.length > 3) num = num.substr(0,3) + '-' + num.substr(3)

  return num
}


export default formatPhoneNumber
